import React, { useCallback, useEffect, useRef } from 'react';
import { ReactComponent as CloseIcon } from '../assets/images/close-icon.svg';
import { useIsMobile } from '../hooks/useIsMobile';

interface ModalProps {
  open: boolean;
  onClose?: () => void,
  children: React.ReactNode,
  theme?: "LIGHT" | "DARK",
  showCloseIcon?: boolean,
  minWidth?: string,
  innerPadding?: boolean
}

const Modal = ({ open, onClose, children, minWidth, theme = 'LIGHT', showCloseIcon=true, innerPadding=true }: ModalProps) => {
  const modalContentRef = useRef<HTMLDivElement>(null);
  const isMobile = useIsMobile();

  if (typeof onClose === "undefined") {
    onClose = () => {};
  }

  const handleClickOutsideEvent = useCallback(
    (e: MouseEvent | TouchEvent) => {
      if (modalContentRef.current && !modalContentRef.current.contains(e.target as Node)) {
        onClose && onClose();
      }
    },
    [onClose],
  );

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutsideEvent);
    document.addEventListener('touchstart', handleClickOutsideEvent);
    return () => {
      document.removeEventListener('mousedown', handleClickOutsideEvent);
      document.removeEventListener('touchstart', handleClickOutsideEvent);
    }
  }, [handleClickOutsideEvent]);

  if (!open) {
    return <></>
  }

  let bgColor = theme === 'LIGHT' ? 'bg-white' : 'bg-dark-grey';
  let iconColor = theme === 'LIGHT' ? '' : 'text-white';

  return <>
    <div className="fixed top-0 left-0 right-0 bottom-0 bg-black/60 w-full h-full z-[9999]"></div>
    <div 
      className={`fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${bgColor} rounded-lg z-[9999] text-dark animate-slide-in-center ${isMobile ? 'w-[calc(100vw-32px)]' : ''}`} 
      ref={modalContentRef} 
      style={{ minWidth: isMobile ? undefined : (minWidth ?? '25rem'), maxWidth: '90vw' }}
    >
      <div className={`relative ${innerPadding ? 'px-4 py-4 lg:px-8' : ''} max-h-[calc(100vh-80px)] overflow-y-auto`}>
        {showCloseIcon ? <CloseIcon className={`absolute right-3 top-3 cursor-pointer ${iconColor}`} width="10px" height="10px" onClick={onClose} /> : null}
        {children}
      </div>
    </div>
  </>
}

export default Modal;